import {
    createEntityAdapter,
    EntityAdapter,
    EntityState
} from '@ngrx/entity';
import { Favourite } from '../../models';
import {
    FavouritesActionFail,
    FavouritesActions,
    FavouritesActionTypes, Upsert
} from './items.actions';
import { getFavouritesEntitiesState } from '../index';
import { remove } from '@app/utils/util-functions';

export interface State extends EntityState<Favourite> {
    loading: boolean;
    loadingFavByCatalogueIds: { number?: number };
}

export const adapter: EntityAdapter<Favourite> = createEntityAdapter<Favourite>(
    {
        selectId: (entity: Favourite) => entity['id'],
        sortComparer: false,
    });

export const initialState: State = adapter.getInitialState(
    {
        loading: false,
        loadingFavByCatalogueIds: {}
    });

export function reducer(
    state = initialState,
    action: FavouritesActions
): State {

    let newState;

    switch (action.type) {
    case FavouritesActionTypes.LOAD:
        return { ...state, loading: true };

    case FavouritesActionTypes.LOAD_SUCCESS:
        newState = { ...state, loading: false };
        return adapter.upsertMany(action.items, newState);
    case FavouritesActionTypes.FAVOURITES_ACTION_FAIL:
        return {
            ...state,
            loading: false,
            loadingFavByCatalogueIds: removeLoadingCatalogueItemId(action, state)
        };
    case FavouritesActionTypes.UPSERT: {
        newState = {
            ...state,
            loading: false,
            loadingFavByCatalogueIds: removeLoadingCatalogueItemId(action, state)
        };
        return adapter.upsertOne(action.item, newState);
    }
    case FavouritesActionTypes.CLEAR: {
        newState = { ...state, loading: false, loadingFavByCatalogueIds: [] };
        return adapter.removeAll(newState);
    }
    case FavouritesActionTypes.SET_FAVOURITE: {
        return {
            ...state,
            loading: true,
            loadingFavByCatalogueIds: { ...state.loadingFavByCatalogueIds, [action.catalogueItemId]: action.catalogueItemId }
        };
    }
    case FavouritesActionTypes.UNSET_FAVOURITE: {
        return {
            ...state,
            loading: true,
            loadingFavByCatalogueIds: { ...state.loadingFavByCatalogueIds, [action.item.catalogueItemId]: action.item.catalogueItemId }
        };
    }
    case FavouritesActionTypes.DELETE: {

        newState = {
            ...state,
            loading: false,
            loadingFavByCatalogueIds: getLoadingFavIdsWithout(action.catalogueItemId, state.loadingFavByCatalogueIds)
        };

        return adapter.removeOne(action.id, newState);
    }

    default: {
        return state;
    }
    }
}

const getLoadingFavIdsWithout = (id: number, ids: { number?: number}) => remove(ids, id);
const removeLoadingCatalogueItemId = (
    action: FavouritesActionFail | Upsert,
    state: State
) => {
    const id = action.type === FavouritesActionTypes.FAVOURITES_ACTION_FAIL ? action.catalogueItemId : action.item.catalogueItemId;
    return !!id ? getLoadingFavIdsWithout(id, state.loadingFavByCatalogueIds) : state.loadingFavByCatalogueIds;
};
export const isLoadingFavourites = (state: State) => state.loading;
export const isLoadingFavouriteFn = (catalogueId) => (state: State) => !!state.loadingFavByCatalogueIds[catalogueId];

export const {
    selectIds: getFavouritesIds,
    selectEntities: getFavouritesEntities,
    selectAll: getAllFavourites,
    selectTotal: getTotalFavourites,
} = adapter.getSelectors();
